export default "__VITE_PUBLIC_ASSET__d47853da__"